module.exports = __webpack_public_path__ + "static/media/deck-3-super.2d74141b.png";